export enum ECisoModuleTabs {
  SecurityPosture = 'security-posture',
  OperationalMetric = 'operational-metric',
  Compliance = 'compliance',
  Perimeter = 'perimeter',
}

export type CISOTabItem = {
  label: string;
  value: ECisoModuleTabs;
  description?: string;
  noDescription?: boolean;
};
